// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, string } from 'prop-types'
import { Field } from 'redux-form'
import Buttons from './Buttons'

import { getUserOptions } from '../../ProjectManagement/helpers'
import { getContactOptions } from '../../PathDb/components/helpers'

import {
  LabeledInput,
  MultiSelectAsync,
  MultiSelectFromState,
} from 'components/Form'

// There's a bug in react-select where default resetValue is null
// But this causes the application to crash because react-select then
// tries to do null.length
const resetValue = {}

const colStyles = {
  width: 'calc(100% / 7)',
}

const Search = ({ highlightedRows, idRoot, sourceForm }) => (
  <ul className={'display-flex width-100 justify-content-between padding-1'}>
    <li style={colStyles}>
      <Field
        autoFocus={true}
        component={MultiSelectAsync}
        id={`${idRoot}create-user`}
        label={'Username'}
        labelKey={'userName'}
        name={'createUserId'}
        isMulti={false}
        optionsResource={getUserOptions}
        resetValue={resetValue}
        sourceForm={sourceForm}
        valueKey={'userId'} />
    </li>
    <li style={colStyles}>
      <Field
        component={LabeledInput}
        id={`${idRoot}-project-name`}
        label={'Project Name'}
        name={'projectName'} />
    </li>
    <li style={colStyles}>
      <Field
        component={MultiSelectAsync}
        id={`${idRoot}contact-codes`}
        label={'Contact Code'}
        labelKey={'contactCode'}
        name={'contactId'}
        optionsResource={getContactOptions}
        sourceForm={sourceForm}
        valueKey={'contactId'} />
    </li>
    <li style={colStyles}>
      <Field
        component={MultiSelectFromState}
        id={`${idRoot}band`}
        label={'Band'}
        name={'bandId'}
        labelKey={'bandDescription'}
        targetSet={['regulatorySettings', 'bands']}
        valueKey={'bandId'} />
    </li>
    <li
      className={'database-search-actions position-relative'}
      style={colStyles}>
      <Buttons
        highlightedRows={highlightedRows}
        idRoot={idRoot}
        sourceForm={sourceForm} />
    </li>
  </ul>
)

Search.propTypes = {
  hasResults: bool.isRequired,
  highlightedRows: array.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Search
